export const WORD_MAP: Map<string, Array<string>> = new Map([
    ['agar', ['SR388']],
    ['ai', ['one']],
    ['aikon', ['first']],
    ['aimar', ['once']],
    ['akala', ['spare', 'spares']],
    ['akalai', ['spared']],
    ['ana', ['I', 'me']],
    ['anamahar', ['my']],
    ['anamis', ['myself']],
    ['aran', ['Aran']],
    ['aranda', ['because']],
    ['arocum', ['teleport']],
    ['aros', ['then']],
    ['aruar', ['offer', 'offers']],
    ['aruari', ['offered']],
    ['ashka', ['if']],
    ['ashkar', ['raven']],
    ['ata', ['you']],
    ['atamahar', ['your', 'yours']],
    ['atamis', ['yourself']],
    ['bados', ['lain']],
    ['bahi', ['truly']],
    ['bala', ['count', 'counts']],
    ['balai', ['counted']],
    ['balan', ['bring', 'brings']],
    ['balani', ['brought']],
    ['balis', ['prowess']],
    ['balta', ['back']],
    ['balu', ['want', 'wants']],
    ['balui', ['wanted']],
    ['bama', ['already']],
    ['ban', ['foolish']],
    ['banta', ['intention', 'intentions']],
    ['barala', ['clone', 'clones']],
    ['baralai', ['cloned']],
    ['barash', ['worship', 'worships']],
    ['bar', ['infect', 'infects']],
    ['bari', ['infected']],
    ['baris', ['serve', 'serves']],
    ['barisi', ['served']],
    ['bash', ['ready']],
    ['behek', ['beak']],
    ['bema', ['leave', 'leaves']],
    ['bemai', ['left']],
    ['bi', ['a', 'an']],
    ['bim', ['as']],
    ['borada', ['simple']],
    ['borodo', ['extinct']],
    ['bunta', ['great']],
    ['bura', ['this', 'these',]],
    ['chado', ['loading']],
    ['chanim', ['before']],
    ['chek', ['let']],
    ['chozo', ['chozo']],
    ['chuba', ['highly']],
    ['chuka', ['lie', 'lies']],
    ['chukai', ['lied']],
    ['daboris', ['proceed', 'proceeds']],
    ['daborisi', ['proceeded']],
    ['danam', ['symbolic']],
    ['dara', ['more']],
    ['darha', ['daughter']],
    ['dim', ['DNA']],
    ['dora', ['should']],
    ['dosh', ['to']],
    ['doshek', ['hand', 'hands']],
    ['dun', ['three']],
    ['duruta', ['gathering']],
    ['ebores', ['somehow']],
    ['eda', ['here']],
    ['eris', ['X']],
    ['eidis', ['enough']],
    ['eka', ['rule', 'rules']],
    ['ekai', ['ruled']],
    ['elar', ['rest', 'rests']],
    ['elari', ['rested']],
    ['elegar', ['prevent', 'prevents']],
    ['elegari', ['prevented']],
    ['eleme', ['narrowly']],
    ['emmi', ['EMMI']],
    ['esen', ['than']],
    ['eshdor', ['must']],
    ['ess', ['now']],
    ['faraga', ['attack', 'attacks']],
    ['faragai', ['attacked']],
    ['fasma', ['weak']],
    ['fehe', ['listen', 'listens']],
    ['fehei', ['listened']],
    ['ferun', ['altar', 'altars']],
    ['gabara', ['possess', 'possesses']],
    ['gabor', ['plot', 'plots']],
    ['gabori', ['plotted']],
    ['gal', ['for']],
    ['galei', ['extreme']],
    ['galkisakra', ['bioweapon']],
    ['garama', ['actually']],
    ['garma', ['caution']],
    ['gelsu', ['soldiers']],
    ['geren', ['continue', 'continues']],
    ['gereni', ['continued']],
    ['gimel', ['galaxy']],
    ['gorgan', ['preparation', 'preparations']],
    ['goro', ['put', 'puts']],
    ['habar', ['has', 'have']],
    ['habari', ['had']],
    ['hadalu', ['destroying']],
    ['hadar', ['power', 'powers']],
    ['hadaris', ['powerful']],
    ['hadoran', ['well']],
    ['hakam', ['turn', 'turns']],
    ['hakami', ['turned']],
    ['hama', ['way', 'ways']],
    ['harek', ['yet']],
    ['haruna', ['live', 'lives']],
    ['harunai', ['lived']],
    ['hasana', ['tribe', 'tribes']],
    ['hasar', ['take', 'takes']],
    ['hasari', ['took']],
    ['has', ['yes']],
    ['hem', ['and']],
    ['henki', ['quiet']],
    ['hol', ['ever']],
    ['horek', ['accomplish', 'accomplishes']],
    ['horeki', ['accomplished']],
    ['hum', ['them', 'they']],
    ['huma', ['being']],
    ['hummahar', ['their']],
    ['hummis', ['themselves']],
    ['hundar', ['become', 'becomes']],
    ['hundari', ['became']],
    ['iamamar', ['follow', 'follows']],
    ['iamamari', ['follows']],
    ['idis', ['manage', 'manages']],
    ['idisi', ['managed']],
    ['ili', ['the']],
    ['ioris', ['plan', 'plans']],
    ['isbi', ['body']],
    ['ish', ['but']],
    ['ishka', ['from']],
    ['kadora', ['would']],
    ['karodan', ['contain', 'contains']],
    ['karodani', ['contained']],
    ['kataru', ['defeat', 'defeats']],
    ['katarui', ['defeated']],
    ['kedar', ['eyes']],
    ['ker', ['five']],
    ['kesa', ['encounter', 'encounters']],
    ['kesai', ['encountered']],
    ['kinu', ['do', 'does']],
    ['kinui', ['done', 'did']],
    ['kisad', ['unlock', 'unlocks']],
    ['kisadi', ['unlocked']],
    ['kohana', ['hold', 'holds']],
    ['kohanai', ['held']],
    ['kran', ['can']],
    ['krani', ['could']],
    ['kuman', ['command', 'commands']],
    ['kumani', ['commanded']],
    ['kuni', ['which']],
    ['ladarha', ['daughter', 'daughters']],
    ['lama', ['force', 'forces']],
    ['lamai', ['forced']],
    ['lavin', ['place', 'places']],
    ['lebat', ['physical']],
    ['les', ['in']],
    ['leshak', ['into']],
    ['lin', ['by']],
    ['loradabor', ['overestimate', 'overestimates']],
    ['loradabori', ['overestimated']],
    ['los', ['was']],
    ['mabor', ['call', 'calls', 'tell', 'tells']],
    ['maboris', ['called', 'told']],
    ['malabun', ['army', 'armies']],
    ['man', ['am']],
    ['manu', ['who']],
    ['mar', ['are']],
    ['maradan', ['ruin', 'ruins']],
    ['maradis', ['robe', 'robes']],
    ['maril', ['will']],
    ['marona', ['until']],
    ['mawkin', ['Mawkin']],
    ['megor', ['descend', 'descends']],
    ['megori', ['descended']],
    ['mehen', ['think', 'imagine', 'believe']],
    ['meheni', ['thought', 'thoughts']],
    ['mehirin', ['needed']],
    ['mei', ['on']],
    ['menke', ['honor', 'honors']],
    ['menkei', ['honored']],
    ['meshta', ['performance', 'performances']],
    ['metroid', ['Metroid', 'Metroids']],
    ['mir', ['that', 'those']],
    ['minobis', ['why']],
    ['mohomo', ['pool', 'pools']],
    ['muk', ['be']],
    ['mugi', ['were', 'was', 'been']],
    ['mul', ['consider', 'considers']],
    ['muli', ['considered']],
    ['mura', ['only']],
    ['mush', ['next']],
    ['nabor', ['instruction', 'instructions']],
    ['nabular', ['dread']],
    ['nakoren', ['alone']],
    ['nalon', ['return', 'returns']],
    ['naloni', ['returned']],
    ['namaianis', ['necessary']],
    ['nebak', ['difficulty', 'difficulties']],
    ['neborien', ['superior']],
    ['nek', ['at']],
    ['nibur', ['intelligence']],
    ['nido', ['disguise', 'disguises']],
    ['nigu', ['know']],
    ['nigui', ['knew']],
    ['nim', ['this', 'it']],
    ['ninu', ['he', 'him']],
    ['ninumahar', ['his']],
    ['ninumis', ['himself']],
    ['nisar', ['close', 'closes']],
    ['nisari', ['closed']],
    ['no', ['it']],
    ['nobe', ['show', 'shows']],
    ['nobei', ['showed', 'shown']],
    ['numu', ['without']],
    ['noras', ['fellow']],
    ['nudakan', ['order']],
    ['nulis', ['within']],
    ['nut', ['with']],
    ['obana', ['measure', 'measures']],
    ['odora', ['longer']],
    ['oibos', ['fulfill', 'fulfills']],
    ['oibosi', ['fulfilled', 'complete']],
    ['ol', ['any']],
    ['olmen', ['everything']],
    ['om', ['all']],
    ['oridion', ['faithfully']],
    ['oro', ['up']],
    ['oromel', ['elevator', 'elevators']],
    ['rahama', ['warrior', 'warriors']],
    ['rem', ['seven']],
    ['sabalba', ['however']],
    ['sabek', ['dangerous']],
    ['sadar', ['scan', 'scans']],
    ['sadari', ['scanned']],
    ['sahali', ['ability', 'abilities']],
    ['sahar', ['aid', 'aids']],
    ['sahari', ['aided']],
    ['saki', ['even']],
    ['salaku', ['scientist', 'scientists']],
    ['salima', ['destiny', 'destinies']],
    ['samus', ['Samus']],
    ['sanul', ['end', 'ends']],
    ['sanuli', ['ended']],
    ['saral', ['eradicate', 'eradicates']],
    ['sarali', ['eradicated']],
    ['sarar', ['gate', 'gates']],
    ['sarien', ['homeworld', 'homeworlds']],
    ['sarin', ['stand', 'stands']],
    ['sarini', ['stood']],
    ['satar', ['use', 'uses']],
    ['satari', ['used']],
    ['satari', ['used']],
    ['sabeis', ['during']],
    ['segura', ['tolerate', 'tolerates']],
    ['segurai', ['tolerated']],
    ['sen', ['is']],
    ['shadaha', ['sacrifice', 'sacrifices']],
    ['sharek', ['there']],
    ['sidur', ['go', 'goes']],
    ['siduri', ['went']],
    ['sirugali', ['unforeseen']],
    ['sol', ['thank', 'thanks']],
    ['suradis', ['rampant']],
    ['sus', ['most']],
    ['tachela', ['right']],
    ['talar', ['running']],
    ['talaris', ['ran']],
    ['tanumar', ['leader', 'leaders']],
    ['tar', ['of']],
    ['tarin', ['ZDR']],
    ['tebolen', ['extract', 'extracts']],
    ['teboleni', ['extracted']],
    ['tera', ['body', 'bodies']],
    ['thoha', ['Thoha']],
    ['tirbon', ['glimpse', 'glimpses']],
    ['tirboni', ['glimpsed']],
    ['tostek', ['purpose', 'purposes']],
    ['tuchoka', ['disobedience']],
    ['tumema', ['resuming']],
    ['turuta', ['worry']],
    ['turaunka', ['disappoint', 'disappoints']],
    ['turaunkai', ['disappointed']],
    ['uliris', ['planet', 'planets']],
    ['ulu', ['not', 'no']],
    ['umauka', ['submit', 'submits']],
    ['umaukai', ['submitted']],
    ['umelia', ['awaken', 'awakens']],
    ['umeliai', ['awakened']],
    ['umi', ['mind', 'minds']],
    ['ura', ['we', 'us']],
    ['uramahar', ['our']],
    ['uramis', ['ourselves']],
    ['uran', ['control', 'controls']],
    ['urani', ['controlled']],
    ['uranes', ['satisfactory']],
    ['utanka', ['chaos']],
])
